import { useState } from "react";
import { useNavigate } from "react-router-dom"
import { useRedux } from "../../../redux/hook/useRedux";
import { actionLoggoutUser } from "../../../redux/user/actions";
import { useUserData } from "../../../context/UserDataContext";
import { useBenefit } from "../../../context/BenefitSelectedContext";

export const useLayoutDashBoard = () => {
    const { benefitSelected, setBenefitSelected } = useBenefit();
    const { dispatch } = useRedux();
    const { userData } = useUserData();
    const navigate = useNavigate();
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const handleLogoutClick = () => {
        dispatch(actionLoggoutUser())
        navigate('/login')
    }

    return {
        navigate,
        sidebarOpen,
        setSidebarOpen,
        handleLogoutClick,
        user: userData,
        benefitSelected,
        setBenefitSelected
    }
}